import { EditorState, Transaction } from "prosemirror-state";

export function insertBr(state: EditorState, dispatch?: (tx: Transaction) => void) {
	if (dispatch) {
		dispatch(
			state.tr.replaceSelectionWith(state.schema.nodes.hard_break.create()).scrollIntoView()
		);
	}
	return true;
}

/** Used in Cafe for the "tab" button.  Maybe not needed here. */
export function insertTab(state: EditorState, dispatch?: (tx: Transaction) => void) {
	if (dispatch) {
		dispatch(state.tr.replaceSelectionWith(state.schema.text("    ")).scrollIntoView());
	}
	return true;
}

/** Used in Cafe for symbol palette.  Maybe not needed here. */
export function insertSymbolFactory(symbol: string) {
	return function insertSymbol(state: EditorState, dispatch?: (tx: Transaction) => void) {
		if (dispatch) {
			dispatch(state.tr.replaceSelectionWith(state.schema.text(symbol)).scrollIntoView());
		}
		return true;
	};
}

/** Used in Cafe for spellcheck's replace feature.  Maybe not needed here. */
export function replaceWordFactory(from: number, to: number, text: string) {
	return function replaceWord(state: EditorState, dispatch?: (tx: Transaction) => void) {
		if (dispatch) {
			dispatch(
				state.tr
					.replaceWith(from, to, state.schema.text(text, state.doc.resolve(from).marks()))
					.scrollIntoView()
			);
		}
		return true;
	};
}
